import type { Bitmap } from "@brickme/project-core/src/bitmap/types.ts";

type SourceImage = {
	readonly bitmap: Bitmap;
	readonly contentType: string;
	readonly fileName: string;
	readonly content: ArrayBuffer;
};

const sourceRotations = [0, 90, 180, 270] as const;

type SourceRotation = (typeof sourceRotations)[number];

export { sourceRotations };
export type { SourceRotation, SourceImage };
